<script lang="ts">
  import { addressesStore, setSelectedAddress, setMode } from "../../lib/stores/addresses";
  import SelectorItem from "./SelectorItem.svelte";
  import Typography from "../Typography.svelte";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import Button from "../Button.svelte";
  import Add from "../../assets/icons/add.svg";
  import { getCopy } from "../../lib/stores/copy";
  import { selectedAddressStore } from "../../lib/stores/addresses";

  export let closeModal: () => void;

  let addresses = $addressesStore.addresses;
  let selectedAddress = $selectedAddressStore?.id;

  const addressSelected = (id: number) => selectedAddress = id;
  const onNewAddressClick = () => setMode("create");
  const onConfirmClick = () => {
    selectedAddress && setSelectedAddress(selectedAddress);
    closeModal();
  };

  $: copy = $getCopy("address") as Record<string, string>;
</script>

<div class="flex flex-col items-center h-full">
  <div class="title flex items-center lg:items-start gap-6 flex-col px-6 py-2 mt-8 lg:py-4 lg:mt-0 w-full">
    <Typography mobile={TypographyType.Headline1} desktop={TypographyType.Headline1} copy={copy.addressLabel} />
  </div>
  <div class="px-6 w-full py-4 overflow-y-scroll overflow-x-hidden">
    {#each addresses as address}
      <SelectorItem {address} selected={selectedAddress === address.id} selectAddress={() => addressSelected(address.id)} />
    {/each}
  </div>
  <div class="buttons w-full p-4 flex flex-col gap-3">
    <Button secondary --button-padding="0.5rem 3.5rem" on:click={onNewAddressClick}>
      <img src={Add} alt={copy.newAddressButtonText} />
      {copy.newAddressButtonText}
    </Button>
    <Button primary --button-padding="0.5rem 3.5rem" on:click={onConfirmClick}>{copy.confirmSelectedAddressButtonText}</Button>
  </div>
</div>

<style>
  @media (min-width: 1024px) {
    .title {
      border-bottom: 1px solid var(--color-grayscale-30);
    }
  }
</style>
